import React from "react";
import { attendanceRows, leaveRequests } from "../../../../data/workspaceData";
import { SectionHeader } from "../../common/WorkspaceChrome";

export function AttendanceView() {
  return (
    <>
    <section className="split-layout">
      <div className="panel">
        <SectionHeader
          eyebrow="Attendance"
          title="Working hours connected to task activity"
          text="Attendance combines manual check-in, tracker signals, approvals, breaks, work mode, and daily summaries."
        />
        <div className="documentation-table-scroll" tabIndex="0">
          <div className="compact-table attendance-documentation-table">
            <div className="documentation-table-heading"><span>Person</span><span>Mode</span><span>Started</span><span>Worked</span><span>Status</span><span>Signal</span></div>
            {attendanceRows.map((row) => (
              <article key={row.employee}>
                <strong>{row.employee}</strong>
                <span>{row.mode}</span>
                <span>{row.checkIn}</span>
                <span>{row.hours}</span>
                <em>{row.status}</em>
                <small>{row.signal}</small>
              </article>
            ))}
          </div>
        </div>
      </div>
      <div className="panel">
        <SectionHeader
          eyebrow="Leave"
          title="Leave requests with approval chain and project impact"
          text="Managers see leave balance, conflicts, capacity impact, and approval history before deciding."
        />
        <div className="documentation-table-scroll" tabIndex="0">
          <div className="request-list documentation-request-list">
            {leaveRequests.map((request) => (
              <article key={`${request.employee}-${request.dates}`}>
                <div>
                  <strong>{request.employee}</strong>
                  <span>{request.type} · {request.dates}</span>
                </div>
                <small>Impact {request.impact}</small>
                <em>{request.status}</em>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
    </>
  );
}
